import React, { Component, PropTypes } from 'react';

class NotFound extends Component {

  render() {
    return (
      <div
        className="l-app-content"
        style={{ textAlign: 'center' }}
      >
        <h1>404</h1>
        <h2>The page you requested is not found.</h2>
        <h4>You may have mistyped the address or the page may have moved!</h4>
      </div>
    );
  }
}


export default NotFound;



// WEBPACK FOOTER //
// ./src/app/components/errors/page-not-found.jsx